import Axios from "../../src/helpers/axios";

export const sendContactUsMail = (payload) => {
  return Axios.post("/api/ecommerce/v1/email/contact-us", payload);
};
